<p-tabView
  [activeIndex]="activeSubComponent"
  (onChange)="onTabActivated($event)"
  styleClass="bfx-tabview"
>
  <p-tabPanel header="Limit" styleClass="user-settings-tab-panel">
    <bfx-notification-settings-limit
      #subComponent
      [audioDisabled]="audioDisabled"
      (audioChanged)="audioChanged($event)"
    >
    </bfx-notification-settings-limit>
  </p-tabPanel>
  <p-tabPanel header="Algo" styleClass="user-settings-tab-panel" *ngIf="algosEnabled">
    <bfx-notification-settings-algo
      #subComponent
      [audioDisabled]="audioDisabled"
      (audioChanged)="audioChanged($event)"
    >
    </bfx-notification-settings-algo>
  </p-tabPanel>
  <p-tabPanel header="Benchmark" styleClass="user-settings-tab-panel" *ngIf="bmarksEnabled">
    <bfx-notification-settings-bmark
      #subComponent
      [audioDisabled]="audioDisabled"
      (audioChanged)="audioChanged($event)"
    >
    </bfx-notification-settings-bmark>
  </p-tabPanel>
  <p-tabPanel header="General" styleClass="user-settings-tab-panel">
    <bfx-notification-settings-general
      #subComponent
      [audioDisabled]="audioDisabled"
      (audioChanged)="audioChanged($event)"
    >
    </bfx-notification-settings-general>
  </p-tabPanel>
  <p-tabPanel header="Email & SMS" styleClass="user-settings-tab-panel">
    <bfx-notification-settings-emailsms #subComponent> </bfx-notification-settings-emailsms>
  </p-tabPanel>
</p-tabView>
